const getDefaultFilterParams = require("./getDefaultFilterParams");

module.exports = (...additionalParams) => (self) => {
  const filter = self.state.filter;
  const params = getDefaultFilterParams(self);

  additionalParams.forEach((key) => {
    params[key] = filter[key] || null;
  });

  return params;
};
